// extracted by mini-css-extract-plugin
export default {"overlayContent":"Loading_overlayContent__j7I6k"};